import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function RequireAuth({ children, requireAccess = true, requireAdmin = false }) {
  const { user, hasAccess, loading } = useAuth();
  const location = useLocation();
  const fromState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
        Loading...
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={fromState} replace />;
  }
  // Force first-time invited users to set their own password before doing anything else.
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (requireAdmin && !user.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }
  if (requireAccess && !hasAccess && !user.is_admin) {
    return <Navigate to="/paywall" replace />;
  }
  return children;
}
